<ng-container *ngIf="highestSlotIndex > 0" #formContainer>
  <form [formGroup]="form" [ngClass]="{'separate-page': isInSeparatePage}">
    <div class="form-fields">
      <ng-container *ngFor="let i of previousNumbersArray;">
        <div
          class="form-field-empty"
          *ngIf="!isNumberInArrayAttribute(i)"></div>
        <ng-container *ngFor="let col of config.columns">
          <div
            *ngIf="(col.formControl && col.formSeparatePageIndex === i &&
            ((col.isCreateField && !this.editObject.id) ||
            (col.isEditField && this.editObject.id))) || highestSlotIndex === 0"
            class="form-field">
            <div class="mb-2">
              <label [htmlFor]="col.field">
                {{ config.translationKey + ".table.columns." + col.field +
                ".title" | translate}}
                <ng-container *ngIf="isRequired(col)"> *</ng-container>
              </label>
              <div
                class="pt-2"
                [ngClass]="col.type === 'boolean' ? 'pt-2' : ''">
                <ng-container [ngSwitch]="col.type">
                  <input
                    [name]="col.field"
                    *ngSwitchCase="'string'"
                    type="text"
                    pInputText
                    class="w-full"
                    [id]="col.field"
                    [placeholder]="'general.form.enterSubject' | translate: {subject: (config.translationKey + '.table.columns.' + col.field + '.placeholder' | translate)}"
                    [formControlName]="col.field"
                    [value]="editObject ? editObject[col.field] : ''" />
                  <input
                    [name]="col.field"
                    *ngSwitchCase="'email'"
                    type="text"
                    pInputText
                    class="w-full"
                    [id]="col.field"
                    [placeholder]="'general.form.enterSubject' | translate: {subject: (config.translationKey + '.table.columns.' + col.field + '.placeholder' | translate)}"
                    [formControlName]="col.field"
                    [value]="editObject ? editObject[col.field] : ''" />
                  <input
                    [name]="col.field"
                    *ngSwitchCase="'telephone'"
                    type="text"
                    pInputText
                    class="w-full"
                    [id]="col.field"
                    [placeholder]="'general.form.enterSubject' | translate: {subject: (config.translationKey + '.table.columns.' + col.field + '.placeholder' | translate)}"
                    [formControlName]="col.field"
                    [value]="editObject ? editObject[col.field] : ''" />
                  <textarea
                    [name]="col.field"
                    *ngSwitchCase="'longText'"
                    rows="5"
                    cols="30"
                    pInputText
                    class="w-full"
                    [id]="col.field"
                    [placeholder]="'general.form.enterSubject' | translate: {subject: (config.translationKey + '.table.columns.' + col.field + '.placeholder' | translate)}"
                    [formControlName]="col.field"
                    [value]="editObject ? editObject[col.field] : ''"></textarea>
                  <p-datepicker
                    [name]="col.field"
                    *ngSwitchCase="'date'"
                    [firstDayOfWeek]="1"
                    [formControlName]="col.field">
                  </p-datepicker>
                  <ng-container [ngSwitch]="col.type">
                    <p-toggleswitch
                      *ngSwitchCase="'boolean'"
                      [formControlName]="col.field">
                    </p-toggleswitch>
                  </ng-container>

                  <p-inputNumber
                    [name]="col.field"
                    *ngSwitchCase="'number'"
                    [formControlName]="col.field"></p-inputNumber>
                  <p-inputNumber
                    [name]="col.field"
                    *ngSwitchCase="'currency'"
                    [mode]="col.type"
                    [currency]=""
                    [currencyDisplay]=""
                    [locale]=""
                    [formControlName]="col.field"></p-inputNumber>
                  <p-inputNumber
                    [name]="col.field"
                    *ngSwitchCase="'decimal'"
                    [mode]="col.type"
                    [currency]=""
                    [currencyDisplay]=""
                    [locale]=""
                    [formControlName]="col.field"></p-inputNumber>
                  <p-select
                    [name]="col.field"
                    *ngSwitchCase="'dropdown'"
                    autoWidth="false"
                    [style]="{'width':'100%'}"
                    [formControlName]="col.field"
                    [options]="col.options"
                    [optionLabel]="col.optionLabel"></p-select>
                  <p-select
                    [name]="col.field"
                    *ngSwitchCase="'enum'"
                    [formControlName]="col.field"
                    autoWidth="false"
                    [style]="{'width':'100%'}"
                    [options]="col.options">
                    <ng-template let-value pTemplate="item">
                      {{ (col.translatePath + '.' + value) | translate }}
                    </ng-template>
                    <ng-template pTemplate="selectedItem" let-value>
                      <span *ngIf="value">
                        {{ (col.translatePath + '.' + value) | translate }}
                      </span>
                    </ng-template>
                  </p-select>
                  <app-file-upload *ngSwitchCase="'files'"></app-file-upload>
                  <app-dynamic-form-comp
                    *ngSwitchCase="'component'"
                    [editObject]="editObject"
                    [columnConfig]="col"></app-dynamic-form-comp>
                </ng-container>
              </div>
              <div class="p-error">
                <div
                  *ngIf="form.controls[col.field].touched && form.controls[col.field].errors?.['required']">
                  {{ 'general.form.validation.error' | translate: { subject:
                  (config.translationKey + ".table.columns." + col.field +
                  ".title" | translate)} }}
                </div>
                <div
                  *ngIf="form.controls[col.field].touched && form.controls[col.field].errors?.['email']">
                  {{ 'general.form.validation.email' | translate: { subject:
                  (config.translationKey + ".table.columns." + col.field +
                  ".title" | translate)} }}
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </div>
  </form>
</ng-container>

<ng-container *ngIf="highestSlotIndex === 0" #formContainer>
  <form [formGroup]="form" [ngClass]="{'separate-page': isInSeparatePage}">
    <div class="form-fields">
      <ng-container *ngFor="let col of config.columns">
        <div
          *ngIf="col.formControl &&
        ((col.isCreateField && !this.editObject.id) ||
          (col.isEditField && this.editObject.id))"
          class="form-field">
          <div class="mb-2">
            <label [htmlFor]="col.field">
              {{ config.translationKey + ".table.columns." + col.field +
              ".title" | translate}}
              <ng-container *ngIf="isRequired(col)"> *</ng-container>
            </label>
            <div class="pt-2" [ngClass]="col.type === 'boolean' ? 'pt-2' : ''">
              <ng-container [ngSwitch]="col.type">
                <app-autocomplete
                  *ngSwitchCase="'autocomplete'"
                  [formControlName]="col.field"
                  [id]="col.field"
                  [placeholder]="'general.form.enterSubject' | translate: {subject: (config.translationKey + '.table.columns.' + col.field + '.placeholder' | translate)}"
                  [columnConfiguration]="col"
                  [defaultValue]="editObject[col.field]" />
                <input
                  *ngSwitchCase="'string'"
                  type="text"
                  pInputText
                  class="w-full"
                  [id]="col.field"
                  [placeholder]="'general.form.enterSubject' | translate: {subject: (config.translationKey + '.table.columns.' + col.field + '.placeholder' | translate)}"
                  [formControlName]="col.field"
                  [value]="editObject ? editObject[col.field] : ''" />
                <input
                  *ngSwitchCase="'email'"
                  type="text"
                  pInputText
                  class="w-full"
                  [id]="col.field"
                  [placeholder]="'general.form.enterSubject' | translate: {subject: (config.translationKey + '.table.columns.' + col.field + '.placeholder' | translate)}"
                  [formControlName]="col.field"
                  [value]="editObject ? editObject[col.field] : ''" />
                <input
                  *ngSwitchCase="'telephone'"
                  type="text"
                  pInputText
                  class="w-full"
                  [id]="col.field"
                  [placeholder]="'general.form.enterSubject' | translate: {subject: (config.translationKey + '.table.columns.' + col.field + '.placeholder' | translate)}"
                  [formControlName]="col.field"
                  [value]="editObject ? editObject[col.field] : ''" />
                <textarea
                  *ngSwitchCase="'longText'"
                  rows="5"
                  cols="30"
                  pInputText
                  class="w-full"
                  [id]="col.field"
                  [placeholder]="'general.form.enterSubject' | translate: {subject: (config.translationKey + '.table.columns.' + col.field + '.placeholder' | translate)}"
                  [formControlName]="col.field"
                  [value]="editObject ? editObject[col.field] : ''"></textarea>
                <p-datepicker
                  *ngSwitchCase="'date'"
                  [id]="col.field"
                  [firstDayOfWeek]="1"
                  [formControlName]="col.field">
                </p-datepicker>
                <p-toggleswitch
                  *ngSwitchCase="'boolean'"
                  [id]="col.field"
                  [formControlName]="col.field"></p-toggleswitch>
                <p-inputNumber
                  *ngSwitchCase="'number'"
                  [id]="col.field"
                  [formControlName]="col.field"></p-inputNumber>
                <p-inputNumber
                  *ngSwitchCase="'currency'"
                  [id]="col.field"
                  [mode]="col.type"
                  [currency]=""
                  [currencyDisplay]=""
                  [locale]=""
                  [formControlName]="col.field"></p-inputNumber>
                <p-inputNumber
                  *ngSwitchCase="'decimal'"
                  [id]="col.field"
                  [mode]="col.type"
                  [currency]=""
                  [currencyDisplay]=""
                  [locale]=""
                  [formControlName]="col.field"></p-inputNumber>
                <p-select
                  *ngSwitchCase="'dropdown'"
                  [id]="col.field"
                  [filter]="col.dropDownFilter"
                  [filterBy]="col.optionLabel"
                  autoWidth="false"
                  [style]="{'width':'100%'}"
                  [formControlName]="col.field"
                  [options]="col.options"
                  [optionLabel]="col.optionLabel"
                  [showClear]="true"
                  [placeholder]="'general.choose' | translate"
                  dataKey="id"></p-select>
                <p-select
                  *ngSwitchCase="'enum'"
                  [id]="col.field"
                  [filter]="col.dropDownFilter"
                  [filterBy]="col.optionLabel"
                  [formControlName]="col.field"
                  autoWidth="false"
                  [style]="{'width':'100%'}"
                  [showClear]="true"
                  [placeholder]="'general.choose' | translate"
                  [options]="col.options">
                  <ng-template
                    *ngIf="col.translatePath"
                    let-value
                    pTemplate="item">
                    {{ (col.translatePath + '.' + value) | translate }}
                  </ng-template>
                  <ng-template
                    *ngIf="col.translatePath"
                    pTemplate="selectedItem"
                    let-value>
                    <span *ngIf="value">
                      {{ (col.translatePath + '.' + value) | translate }}
                    </span>
                  </ng-template>
                </p-select>
                <app-file-upload
                  *ngSwitchCase="'files'"
                  (fileRemoved)="fileRemoved($event)"
                  (choose)="filesChosen($event, col.field)"></app-file-upload>
                <app-dynamic-form-comp
                  *ngSwitchCase="'component'"
                  [editObject]="editObject"
                  [columnConfig]="col"></app-dynamic-form-comp>
              </ng-container>
              <div
                class="pt-4"
                *ngIf="config.fileDownloadContext && col.type === 'files' && editObject[col.field] && editObject[col.field].length > 0">
                <div class="pb-2">
                  {{'general.alreadyUploadedFiles' | translate}}
                </div>
                <div>
                  <app-files
                    [filesList]="editObject[col.field]"
                    [context]="config.fileDownloadContext"
                    (fileRemoved)="fileRemoved($event)"
                    (choose)="filesChosen($event, col.field)"></app-files>
                </div>
              </div>
            </div>
            <div class="p-error">
              <div
                *ngIf="form.controls[col.field].touched && form.controls[col.field].errors?.['required']">
                {{ 'general.form.validation.error' | translate: { subject:
                (config.translationKey + ".table.columns." + col.field +
                ".title" | translate)} }}
              </div>
              <div
                *ngIf="form.controls[col.field].touched && form.controls[col.field].errors?.['email']">
                {{ 'general.form.validation.email' | translate: { subject:
                (config.translationKey + ".table.columns." + col.field +
                ".title" | translate)} }}
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </form>
</ng-container>
